module.exports = __webpack_public_path__ + "static/media/feature2.b8b576b4.jpeg";